import {
  ImportTemplate as OctopusImportTemplate,
  ImportTemplateFieldOptionsResponse,
} from '../models/import-manager';
import { ConfigurationMapper } from './configuration';
import {
  ImportTemplateFieldOption,
  ImportTemplateProperty,
} from '../../../models';
import { SecurityAccessItem } from '../models/security-access';
import { Mapper } from '../../../mappers';

export class ImportTemplateFieldOptionMapper extends ConfigurationMapper<
  ImportTemplateFieldOptionsResponse,
  ImportTemplateFieldOption
> {
  from(source: ImportTemplateFieldOptionsResponse): ImportTemplateFieldOption {
    const importTemplate = source.ImportTemplate?.FieldOptions;

    return {
      readAccess:
        importTemplate?.SecAccess?.Read?.map(this.mapSecurityAccess) ?? [],
      fullAccess:
        importTemplate?.SecAccess?.Write?.map(this.mapSecurityAccess) ?? [],
    };
  }
}
export class ImportTemplatePropertyMapper extends Mapper<
  OctopusImportTemplate,
  ImportTemplateProperty
> {
  from(source: OctopusImportTemplate): ImportTemplateProperty {
    return {
      key: source.Key,
      name: source.Name,
      readAccess: source.SecAccess?.Read[0].Key.Value ?? '*',
      fullAccess: source.SecAccess?.Write[0].Key.Value ?? '*',
      canUpdate: source.SecStatus?.CanUpdate,
    } as ImportTemplateProperty;
  }
}

export class ImportTemplatePropertyFormMapper extends Mapper<
  ImportTemplateProperty,
  OctopusImportTemplate
> {
  from(source: ImportTemplateProperty): OctopusImportTemplate {
    return {
      Key: source.key,
      Name: source.name,
      SecAccess: {
        Read: [{ Key: { Value: source.readAccess } } as SecurityAccessItem],
        Write: [{ Key: { Value: source.fullAccess } } as SecurityAccessItem],
      },
    } as OctopusImportTemplate;
  }
}
